<template>
  <div :id="chartId">
    <a-empty v-if="!chartData.length" style="padding-top: 48px;"></a-empty>
  </div>
</template>

<script>
import { Chart } from '@antv/g2'

const chart = {}

export default {
  name: 'BarChartUsageTop',
  props: {
    chartData: {
      type: Array,
      default: () => []
    },
    chartId: {
      type: String,
      required: true
    },
    height: {
      type: Number,
      default: 240
    },
    unit: {
      type: String,
      default: '%'
    },
    bgColor: {
      type: [String, Array, Function]
    },
    barColor: {
      type: [String, Array, Function]
    },
    eventList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      data: [],
      view2Data: []
    }
  },
  mounted () {
    chart[this.chartId] = new Chart({
      container: this.chartId,
      autoFit: true,
      height: this.height,
      appendPadding: [16, 4, 0, 4]
    })
    chart[this.chartId].scale({
      value: {
        min: 0,
        max: 100,
        alias: '使用率'
      },
      default: {
        min: 0,
        max: 100
      }
    })
    chart[this.chartId].axis('default', {
      grid: null,
      label: null
    })
    chart[this.chartId].axis('value', {
      grid: {
        line: {
          type: 'line',
          style: {
            lineDash: [6, 4]
          }
        }
      }
    })
    chart[this.chartId].axis('name', {
      label: {
        autoEllipsis: true,
        autoHide: false
      },
      line: null,
      tickLine: null,
      verticalLimitLength: 0.35
    })
    chart[this.chartId].legend(false)
    // chart[this.chartId].tooltip({
    //   showTitle: false,
    //   showMarkers: false,
    //   itemTpl: '<div style="font-size: 14px; line-height: 22px;"><div><span style="display: inline-block;width: 6px;height: 6px;background: #44D7B6;margin-right: 4px;margin-bottom: 2px;"></span>总空间：{total}GB</div><div style="margin-bottom: 8px;"><span style="display: inline-block;width: 6px;height: 6px;background: #FAAD14;margin-right: 4px;margin-bottom: 2px;"></span>已用空间：{usage}GB</div></div>'
    // })
    if (this.barColor) {
      chart[this.chartId]
        .interval()
        .size(16)
        .position('name*value')
        .color('value', this.barColor)
        .label('value', {
          offset: 10,
          style: {
            fill: '#777A7C',
            fontSize: 12,
            fontWeight: '500'
          },
          content: (item) => {
            return `${item.value} ${this.unit}`
          }
        })
        .tooltip(false)
    } else {
      chart[this.chartId]
        .interval()
        .size(16)
        .position('name*value')
        .color('value', (val) => {
          if (val >= 90) {
            return 'l(90) 0:#FF9293 1:#FF393F'
          } else return 'l(90) 0:#15A6EE 1:#096DD9'
        })
        .label('value', {
          offset: 10,
          style: {
            fill: '#777A7C',
            fontSize: 12,
            fontWeight: '500'
          },
          content: (item) => {
            return `${item.value} ${this.unit}`
          }
        })
        .tooltip(false)
    }

    if (this.bgColor) {
      chart[this.chartId]
        .interval()
        .size(40)
        .position('name*default')
        .color('value', this.bgColor)
        .tooltip(false)
    } else {
      chart[this.chartId]
        .interval()
        .size(40)
        .position('name*default')
        .color('value', (val, a, b) => {
          if (val >= 90) {
            return '#FF6A6D15'
          } else return '#1190E615'
        })
        .tooltip(false)
    }

    this.render()

    if (this.eventList.length) {
      for (let i = 0; i < this.eventList.length; i++) {
        const event = this.eventList[i]
        chart[this.chartId].on(event.type, event.func)
      }
    }

    chart[this.chartId].interaction('element-highlight')
  },
  methods: {
    render () {
      if (this.chartData.length === 0) {
        chart[this.chartId].changeVisible(false)
      } else {
        this.chartData.forEach(item => {
          item.default = 100
        })
        chart[this.chartId].changeData(this.chartData)
        chart[this.chartId].changeVisible(true)
      }
    }
  },
  watch: {
    chartData () {
      this.render()
    }
  }
}
</script>
